// Android 套壳通过 webView.addJavascriptInterface 注入 window.AndroidBridge。
// Capacitor plugin 在远程域名下被禁，所以走 WebView 级原生接口而不是 @capacitor/browser。

/** 已带协议或特殊 scheme（https:、mailto:、tel: 等）的地址 */
const SCHEME_RE = /^[a-z][a-z0-9+.-]*:/i

/**
 * 规范化外部链接地址：
 * - 去掉首尾空白（后台录入常带空格）
 * - `//host` 形式补 https:
 * - 没有任何协议且不是站内路径（`/xxx`）的裸域名补 https://，避免被当作相对路径拼到当前站点后面
 */
export function normalizeExternalUrl(url: string | null | undefined): string {
  const trimmed = (url ?? '').trim()
  if (!trimmed) return ''
  if (SCHEME_RE.test(trimmed)) return trimmed
  if (trimmed.startsWith('//')) return `https:${trimmed}`
  if (trimmed.startsWith('/') || trimmed.startsWith('#')) return trimmed
  return `https://${trimmed}`
}

export function openExternal(url: string): void {
  const target = normalizeExternalUrl(url)
  if (!target) return
  const bridge = (globalThis as unknown as {
    AndroidBridge?: { openCustomTabs?: (url: string) => void }
  }).AndroidBridge
  if (bridge?.openCustomTabs) {
    bridge.openCustomTabs(target)
    return
  }
  window.open(target, '_blank', 'noopener,noreferrer')
}
